
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { logger } from '@recommendation/helpers'
import { trackProductImpressionBatched } from '@tracking/events'

import HighlightedProductCard from './HighlightedProductCard.vue'
import ProductAd from './ProductAd'
import ProductCard from './ProductCard.vue'

export default {
  components: {
    ProductCard,
    ProductAd,
    HighlightedProductCard,
  },
  props: {
    recommendations: {
      type: Array,
      required: true,
    },
    highlightedProduct: {
      type: Object,
      default: undefined,
    },
    searchResults: {
      type: Array,
      required: true,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    showAdvert: {
      type: Boolean,
      default: false,
    },
    showBuyingGuide: {
      type: Boolean,
      default: false,
    },
    showPaymentMethodAdvertising: {
      type: Boolean,
      default: false,
    },
    showRecommendations: {
      type: Boolean,
      default: true,
    },
    recommendationWidgetId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      productImpressions: [],
      trackingInterval: null,
    }
  },

  computed: {
    ...mapGetters({
      country: 'config/country',
    }),

    totalResultDisplayed() {
      const recoLength = this.showRecommendations
        ? this.recommendations.length
        : 0

      return recoLength + this.searchResults.length
    },

    advertClassNames() {
      return {
        'row-start-4 col-span-full': this.wide && this.totalResultDisplayed > 2,
        'row-start-6 md:row-start-3 md:col-start-2 lg:row-start-2 lg:col-start-3':
          !this.wide && this.totalResultDisplayed > 4,
      }
    },

    advertPosition() {
      if (this.wide && this.totalResultDisplayed > 2) {
        return 4
      }

      if (!this.wide && this.totalResultDisplayed > 4) {
        return 6
      }

      return this.totalResultDisplayed + 1
    },

    buyingGuideClassNames() {
      return this.buyingGuidePaymentMethodAdClassNames(this.showAdvert)
    },

    paymentMethodAdClassNames() {
      const hasReadyAnotherAd = this.showAdvert || this.showBuyingGuide

      return this.buyingGuidePaymentMethodAdClassNames(hasReadyAnotherAd)
    },
  },

  mounted() {
    this.trackingInterval = setInterval(() => {
      if (!isEmpty(this.productImpressions)) {
        try {
          trackProductImpressionBatched(this.productImpressions)
        } catch (error) {
          logger.info(error, {
            component: { name: 'CardsList', props: this.$props },
            routeName: this.$route.name,
          })
        } finally {
          this.productImpressions = []
        }
      }
    }, this.$config.BATCH_TRACKING_INTERVAL)
  },

  beforeDestroy() {
    clearInterval(this.trackingInterval)
  },

  methods: {
    saveImpression(productTracking) {
      this.productImpressions.push(productTracking)
    },

    buyingGuidePaymentMethodAdClassNames(hasReadyAnotherAd) {
      if (hasReadyAnotherAd) {
        return this.wide
          ? 'row-start-[8] col-span-full'
          : 'row-start-[12] md:row-start-6 md:col-start-2 lg:row-start-4 lg:col-start-3'
      }

      return this.wide
        ? 'row-start-4 col-span-full'
        : 'row-start-6 md:row-start-3 md:col-start-2 lg:row-start-2 lg:col-start-3'
    },
  },
}
